'use client';

import { stopImpersonation } from '@/app/admin/dashboard/admin-actions';

import { Button } from '../ui/button';

export function StopImpersonationButton() {
  return (
    <Button
      onClick={async () => {
        await stopImpersonation();
        location.href = '/admin/dashboard';
      }}
      variant='outline'
      size='sm'
    >
      Stop
    </Button>
  );
}
